import { useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";

import AccountOrders from "./AccountOrders";
import AccountProfile from "./AccountProfile";
import AccountAddresses from "./AccountAddresses";

import "./AccountHome.css";

export default function AccountHome() {
  const { profile, loadingPerfil } = useOutletContext();

  const [openSection, setOpenSection] = useState(null);

  const fullName = useMemo(() => {
    const n = String(profile?.nombre || "").trim();
    const a = String(profile?.apellido || "").trim();
    const joined = `${n} ${a}`.trim();
    return joined || "Cliente";
  }, [profile?.nombre, profile?.apellido]);

  const toggle = (key) => {
    setOpenSection((current) => (current === key ? null : key));
  };

  const showOrders = openSection === "orders";
  const showProfile = openSection === "profile";
  const showAddresses = openSection === "addresses";

  return (
    <div className="adc-home" aria-busy={loadingPerfil ? "true" : "false"}>
      <section className="adc-homeCard">
        <div className="adc-homeHead">
          <h2 className={`adc-homeTitle ${loadingPerfil ? "is-loading" : ""}`}>
            {loadingPerfil ? "Bienvenido" : `Hola, ${fullName}`}
          </h2>

          <p className="adc-homeSubtitle">
            Desde aquí puedes administrar tu cuenta: revisar pedidos, actualizar
            tu perfil o gestionar tus direcciones de envío.
          </p>
        </div>

        <div className="adc-homeButtons">
          <button
            type="button"
            className={`adc-homeBtn ${showOrders ? "is-active" : ""}`}
            onClick={() => toggle("orders")}
            aria-expanded={showOrders}
          >
            <div className="adc-homeBtn__title">
              {showOrders ? "Ocultar pedidos" : "Pedidos"}
            </div>
            <div className="adc-homeBtn__desc">
              Revisa el estado y detalles
            </div>
          </button>

          <button
            type="button"
            className={`adc-homeBtn ${showProfile ? "is-active" : ""}`}
            onClick={() => toggle("profile")}
            aria-expanded={showProfile}
          >
            <div className="adc-homeBtn__title">
              {showProfile ? "Ocultar perfil" : "Perfil"}
            </div>
            <div className="adc-homeBtn__desc">
              Edita tus datos personales
            </div>
          </button>

          <button
            type="button"
            className={`adc-homeBtn ${showAddresses ? "is-active" : ""}`}
            onClick={() => toggle("addresses")}
            aria-expanded={showAddresses}
          >
            <div className="adc-homeBtn__title">
              {showAddresses ? "Ocultar direcciones" : "Direcciones"}
            </div>
            <div className="adc-homeBtn__desc">
              Administra tus ubicaciones
            </div>
          </button>
        </div>
      </section>

      {showOrders && (
        <section className="adc-homeSection">
          <AccountOrders embedded />
        </section>
      )}

      {showProfile && (
        <section className="adc-homeSection">
          <AccountProfile embedded />
        </section>
      )}

      {showAddresses && (
        <section className="adc-homeSection">
          <AccountAddresses embedded />
        </section>
      )}
    </div>
  );
}